import {observer} from "mobx-react";
import React from "react";
import {ContentData, ContentInputs, SubContentInputs, ContentDataInput, ContentInput} from "./styled";
import {useValidatorInputTickets} from "@dropDesk/presentation/pages/ticket/ui/form_create/inputs/validator";
import InputWithBorder from "@dropDesk/presentation/components/inputs/input_with_border";
import {useBetween} from "use-between";
import SelectSearchMain from "@dropDesk/presentation/components/inputs/select_search_main";
import {TicketEntity} from "@dropDesk/domain/entities/ticket/ticket.entity";
import {removeMaskStaticTelephoneNumber} from "@dropDesk/utils/helpers/string_helper";
import {useModalCreateTicket} from "@dropDesk/presentation/pages/ticket/ui/form_create/modals/handle_change_visible";
import {Tooltip} from "antd";
import InputsProblemDescription
    from "@dropDesk/presentation/pages/ticket/ui/form_create/inputs/inputs_problem_description";
import InputDateDue from "@dropDesk/presentation/pages/ticket/ui/form_create/inputs/input_date_due";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import SelectSearchClient from "@dropDesk/presentation/components/inputs/select_search_clients";
import {ClientEntity} from "@dropDesk/domain/entities/client/client.entity";
import {UserRole} from "@dropDesk/domain/entities/user/user_enum";
import SelectSearchUser from "@dropDesk/presentation/components/inputs/select_search_users";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";
import SelectSearchSector from "@dropDesk/presentation/components/inputs/select_search_sectors";
import {SectorEntity} from "@dropDesk/domain/entities/sector/sector.entity";
import {
    TicketsDescriptionStaticEntity
} from "@dropDesk/domain/entities/ticket_description_static/ticket_description_static.entity";

const InputsFormCreateTickets = observer(
    ({
         ticket,
         onUpdate,
         loading,
         isEdit,
         handleRemoveClient,
         useProblemStatic,
         permissionScreenClients,
         isNewChat,
         handleSelectClientAndDependOpenModal,
         handleSelectContact,
         handleSelectSector,
         idUserLogged,
         handleSelectUserAttendant,
         idSector,
         handleSelectDescriptionStatic
     }: {
        ticket: TicketEntity,
        onUpdate: (ticket: TicketEntity) => void,
        loading: boolean,
        useProblemStatic: boolean,
        isEdit?: boolean,
        permissionScreenClients?: boolean,
        handleRemoveClient: () => void
        isNewChat?: boolean,
        handleSelectClientAndDependOpenModal: (client: ClientEntity) => Promise<boolean>,
        handleSelectContact: (contact: UserEntity) => void,
        handleSelectSector: (sector: SectorEntity) => void,
        idUserLogged?: string
        idSector?: string
        handleSelectUserAttendant: (user: UserEntity) => void,
        handleSelectDescriptionStatic: (descriptionStatic: TicketsDescriptionStaticEntity) => void,

    }) => {

        const appController = useInjection(AppController);

        const {
            setVisibleModalCreateClient,
        } = useBetween(useModalCreateTicket);



        const {
            errorMessageClient, errorMessageContact, errorMessageSector, errorMessageDateDue, errorMessageAttendant,
            errorMessageDescription
        } = useValidatorInputTickets(ticket);

        const handleAllChanges = (event: {
            target: { name: string; value: any; checked?: any; type: string }
        }) => {

            const _ticket = ticket.copyWith({
                [event.target.name]:
                    (event.target.type === "checkbox" || event.target.type === "switch") ?
                        event.target.checked : event.target.name === "telephone" ?
                            removeMaskStaticTelephoneNumber(event.target.value.replace(/\D/g, "")) :
                            event.target.value,

                replaceDateDueIfNull: event.target.name === "dateDue",
            });
            onUpdate(_ticket);

        };

        return (
            <ContentInputs>
                <SubContentInputs>
                    <ContentData>
                        {!appController.isUserClient &&
                            <ContentDataInput>
                                <ContentInput style={{marginRight: 20}}>
                                    <SelectSearchClient
                                        required={true}
                                        size={37}
                                        useRemoveFilter={(!!ticket.userClient && !isNewChat)}
                                        disabled={(loading || isEdit || isNewChat)}
                                        disabledButtonRight={loading}
                                        placeHolder={"Selecione a empresa"}
                                        messageError={errorMessageClient}
                                        label={"Empresa"}
                                        value={ticket.client ? {
                                            value: ticket.client.id,
                                            label: !!ticket.client.socialName ? ticket.client.socialName : ticket.client.name,
                                        } : undefined}
                                        useButtonRight={isNewChat ? false : permissionScreenClients}
                                        labelButtonRight={isEdit ? "Editar" : "Nova empresa"}
                                        onClickButtonRight={() => {
                                            setVisibleModalCreateClient(true);
                                        }}
                                        handleSelectClient={async (filter, client) => {
                                            if (client) {
                                                const isOpenSelectSearchContact = await handleSelectClientAndDependOpenModal(client);
                                                if (isOpenSelectSearchContact) {
                                                    //TALVEZ abrir select do contacto ja com idCLient
                                                }
                                            } else {
                                                handleRemoveClient();
                                            }
                                        }}
                                    />
                                </ContentInput>
                                <ContentInput>
                                    <SelectSearchUser
                                        required={true}
                                        size={37}
                                        useRemoveFilter={false}
                                        label={'Contato'}
                                        placeHolder={"Selecione o contato"}
                                        handleSelectUser={(value, user) => {
                                            if (user) {
                                                handleSelectContact(user);
                                            }
                                        }}
                                        idClient={ticket.client?.id}
                                        messageError={errorMessageContact}
                                        disabled={loading || !!isEdit}
                                        value={ticket.userClient ? {
                                            value: ticket.userClient.id,
                                            label: ticket.userClient.name
                                        } : undefined}
                                        role={UserRole.userClient}
                                    />
                                </ContentInput>
                            </ContentDataInput>}
                        <ContentDataInput>
                            <ContentInput style={{marginRight: appController.isUserClient ? 0 : 20}}>
                                <SelectSearchSector
                                    required={true}
                                    size={37}
                                    useRemoveFilter={false}
                                    label={'Setor'}
                                    placeHolder={"Selecione um setor"}
                                    messageError={errorMessageSector}
                                    handleSelectSector={(value, sector) => {
                                        if (sector) {
                                            handleSelectSector(sector);
                                        }
                                    }}
                                    idUser={idUserLogged}
                                    value={ticket.sector ? {
                                        value: ticket.sector.id,
                                        label: ticket.sector?.realName(appController.user!) ?? ''
                                    } : undefined}
                                    disabled={loading || !!isEdit}
                                />
                            </ContentInput>
                            {!appController.isUserClient && <Tooltip
                                title={!ticket.sector ? "Selecione um setor para poder selecionar um atendente." : ""}>
                                <ContentInput>
                                    <SelectSearchUser
                                        size={37}
                                        useRemoveFilter={false}
                                        label={'Atendente'}
                                        placeHolder={"Selecione o atendente"}
                                        handleSelectUser={(value, user) => {
                                            if(user){
                                                handleSelectUserAttendant(user);
                                            }
                                        }}
                                        value={ticket.attendant ? {value: ticket.attendant.id, label: ticket.attendant.name ?? ''} : undefined}

                                        role={UserRole.attendant}
                                        disabled={(loading || !!isEdit || !ticket.sector)}
                                        messageError={errorMessageAttendant}
                                        idSector={idSector}
                                    />
                                </ContentInput>
                            </Tooltip>}
                        </ContentDataInput>

                        {!appController.isUserClient && <ContentDataInput>
                            <ContentInput style={{marginRight: 20, marginBottom: 25}}>
                                <SelectSearchMain<string>
                                    required={true}
                                    size={37}
                                    name={'priority'}
                                    label={"Prioridade"}
                                    options={appController.ticketPriorityConfigs.map((item) => item.toOptionType())}
                                    removeSort={true}
                                    onChange={(value) => {
                                        handleAllChanges({
                                            target: {
                                                name: 'priority',
                                                value: value,
                                                checked: false,
                                                type: 'input'
                                            }
                                        })
                                    }}
                                    value={ticket.priority ?? null}
                                />
                            </ContentInput>
                            <ContentInput>
                                <InputDateDue
                                    ticket={ticket}
                                    errorMessageDateDue={errorMessageDateDue}
                                    handleAllChanges={handleAllChanges}
                                    minDate={new Date()}
                                />
                            </ContentInput>
                        </ContentDataInput>}
                        <InputsProblemDescription
                            ticket={ticket}
                            useProblemStatic={useProblemStatic}
                            loading={loading}
                            handleAllChanges={handleAllChanges}
                            errorMessageDescription={errorMessageDescription}
                            handleSelectDescriptionStatic={handleSelectDescriptionStatic}
                        />
                    </ContentData>
                </SubContentInputs>

            </ContentInputs>
        )
    })
export default InputsFormCreateTickets;
